import type { PropsWithChildren, ReactNode } from 'react';
import type { TCategoryPickerItem } from './components/CategoryPickerItem/CategoryPickerItem';
import type { UmbracoAlgoliaCategories } from '~/lib/data-contract/auto-generated/api-model';
import type { PLPHeroProps } from './components/PLPHero/PLPHero';
import type { ToggleRefinementValue } from 'instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement';
import type { InstantSearchServerState } from 'react-instantsearch';

export type TFacet = {
    name?: string;
    label: string;
    count?: number;
    value: string;
    isRefined?: boolean;
    icon?: ReactNode;
};

export type TToggleFacet = {
    name?: string;
    label: string;
    count?: number;
    value?: ToggleRefinementValue;
    isRefined?: boolean;
    icon?: ReactNode;
};

export type TPLPModule = PLPHeroProps &
    PropsWithChildren<{
        rootPath?: string;
        categories?: TCategoryPickerItem[];
        hitsPerPage?: number;
        facets?: TFacet[];
        parent?: TCategoryPickerItem;
        filters: string;
        dataType?: keyof typeof UmbracoAlgoliaCategories;
        parentDataConfiguration?: string;
        parentDataType?: keyof typeof UmbracoAlgoliaCategories;
        serverState?: { serverState: InstantSearchServerState; serverUrl: string };
    }>;

export type FilterTypes = 'Category Id' | 'Context Rule Name';

export type ProductPromotionTypeRedirect = 'mixandmatch' | 'bastard' | 'bundle';

export type PLPResult = { serverState: InstantSearchServerState; serverUrl: string };

export enum AlgoliaHitType {
    PROMOTIONAL_CONTENT = 'promotional_content',
}
